import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':jobId'}/invoices/${number | ':invoiceId'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/:jobId/invoices/:invoiceId`;

export const URL = (jobId: number, invoiceId: number): RouteDefinition => `${baseRoute}/${jobId}/invoices/${invoiceId}`;
